import { motion } from "framer-motion";

const HERO_NIGHT = "https://static.prod-images.emergentagent.com/jobs/e3008f40-7468-48a5-b0f3-bace2e1b48d6/images/dde5cb7d515d16bd23a3a4f41369d3c70deb4db4f33a3aed3a8b74d3a30e61e2.jpeg";
const HERO_DAY = "https://static.prod-images.emergentagent.com/jobs/e3008f40-7468-48a5-b0f3-bace2e1b48d6/images/167d5283a5c1d268ee9112d3bc6ba66c6594738aaaf1c5c86aad755bceed21de.jpeg";

// Faceless Makkah–Madinah hero (day/night by local time) with salam + the pilgrim's name.
export function DashboardHero({ name }) {
  const hour = new Date().getHours();
  const heroSrc = hour >= 6 && hour < 18 ? HERO_DAY : HERO_NIGHT;
  return (
    <div
      className="relative overflow-hidden rounded-3xl h-44 md:h-60 flex flex-col justify-end p-6"
      data-testid="dashboard-hero"
    >
      {/* faceless illustration background (day/night by local time) */}
      <motion.img
        key={heroSrc}
        src={heroSrc}
        alt="Makkah & Madinah"
        initial={{ scale: 1.12, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.4, ease: "easeOut" }}
        className="absolute inset-0 h-full w-full object-cover"
        data-testid="dashboard-hero-img"
      />
      {/* emerald gradient overlay keeps salam & name legible on both variants */}
      <div className="absolute inset-0" style={{ background: "linear-gradient(120deg, rgba(10,59,43,0.86) 0%, rgba(15,90,63,0.55) 50%, rgba(10,59,43,0.45) 100%)" }} />
      <div className="absolute -top-16 -end-10 h-56 w-56 rounded-full opacity-30 blur-3xl" style={{ background: "radial-gradient(circle, #E6C25C 0%, transparent 70%)" }} />
      <div className="absolute inset-0 ring-1 ring-inset ring-[#E6C25C]/25 rounded-3xl pointer-events-none" />
      <p
        className="arabic-text relative text-white text-xl md:text-3xl leading-relaxed mb-2 drop-shadow"
        dir="rtl"
        data-testid="dashboard-greeting"
      >
        السَّلاَمُ عَلَيْكُمْ وَرَحْمَةُ اللهِ وَبَرَكَاتُهُ
      </p>
      <h1 className="relative text-2xl md:text-3xl font-medium tracking-tight text-white" style={{ fontFamily: "Arial, Helvetica, sans-serif" }} data-testid="dashboard-user-name">
        {name || ""}
      </h1>
    </div>
  );
}
